export const MENU = [
  {
    path: '/home',
    name: 'Home',
  },
  {
    path: '/webpages',
    name: 'Webpages',
    showWhenFeatureEnabled: 'per-url-monitoring',
    children: [
      {
        path: '/webpages/add',
        name: 'Add Webpage',
      },
      {
        path: '/webpages/list',
        name: 'View Webpages',
      },
    ],
  },
  {
    path: '/domain',
    name: 'Domains',
    showWhenFeatureEnabled: 'per-domain-monitoring',
    children: [
      {
        path: '/domain/add',
        name: 'Add Domain',
      },
      {
        path: '/domain/list',
        name: 'View Domains',
      },
      {
        path: '/domain/add-webpage',
        name: 'Add Webpages',
      },
      {
        path: '/domain/add-crawl-schedule',
        name: 'Add Crawl Schedule',
      },
      {
        path: '/domain/list-crawl-schedule',
        name: 'List Crawl Schedule',
      },
    ],
  },
  {
    path: '/tags/list',
    name: 'Tags',
    showWhenFeatureEnabled: 'tags',
  },
  {
    path: '/blackout-period',
    name: 'Blackout Periods',
    children: [
      {
        path: '/blackout-periods/list',
        name: 'Blackout Periods',
      },
      {
        path: '/blackout-periods/add',
        name: 'Add Blackout Period',
      },
    ],
  },
  {
    path: '/batch-jobs',
    name: 'Batch Jobs',
    children: [
      {
        path: '/batch-jobs/list',
        name: 'View Batch Jobs',
      },
    ],
  },
  {
    path: '/incident/list',
    name: 'Alerts',
  },
  {
    path: '/change-events',
    name: 'Aggregated Alerts',
    showWhenFeatureEnabled: 'change-events',
    children: [
      {
        path: '/change-events/site-incidents',
        name: 'Site-Wide Incidents',
      },
      {
        path: '/change-events/overview',
        name: 'Overview',
      },
      {
        path: '/change-events/list',
        name: 'Grouped Alerts',
      },
      {
        path: '/change-events/settings',
        name: 'Settings',
      },
    ],
  },
  {
    path: '/notification',
    name: 'Notifications',
    children: [
      {
        path: '/contact/list',
        name: 'Contacts',
      },
      {
        path: '/contact-group/list',
        name: 'Contact Groups',
      },
      {
        path: '/notification/list',
        name: 'Notification Settings',
      },
      {
        path: '/notification/history',
        name: 'Notification History',
      },
      {
        path: '/telegram-notification/list',
        name: 'Telegram Notification',
      },
    ],
  },
  {
    path: '/policy',
    name: 'Policies',
    children: [
      {
        path: '/policy/list',
        name: 'Policies',
      },
      {
        path: '/policy/add',
        name: 'Add Policy',
      },
      {
        path: '/policy/bulk-rules',
        name: 'Bulk Edit',
      },
      {
        path: '/policy/rendering',
        name: 'Rendering Config',
      },
    ],
  },
  {
    path: '/ai-triage',
    name: 'AI Triage',
    showWhenFeatureEnabled: 'alert-triage',
  },
  {
    path: '/auto-finetune',
    name: 'Auto Finetune',
    children: [
      {
        path: '/auto-finetune/landing',
        name: 'Run / Schedule',
      },
      {
        path: '/auto-finetune/suggestions',
        name: 'Suggestions',
      },
    ],
  },
  {
    path: '/polling-history',
    name: 'Polling History',
    children: [
      {
        path: '/polling-history/baseline-history',
        name: 'View Baseline',
      },
      {
        path: '/polling-history/verify-history',
        name: 'View Verify Records',
      },
    ],
  },
  {
    path: '/traffic-config',
    name: 'Traffic Configuration',
    showWhenFeatureEnabled: 'traffic-configuration',
  },
  {
    path: '/domain-monitoring',
    name: 'SSL/DNS/Whois Monitoring',
    showWhenFeatureEnabled: 'dns-ssl-whois-monitoring',
    children: [
      {
        path: '/domain-monitoring/add-domain',
        name: 'Add Configuration',
      },
      {
        path: '/domain-monitoring/list',
        name: 'View Records',
      },
    ],
  },
  {
    path: '/web-crawl',
    name: 'Website Crawl',
    showWhenFeatureEnabled: 'firecrawl',
    children: [
      {
        path: '/web-crawl/new',
        name: 'Start Crawl',
      },
      {
        path: '/web-crawl/history',
        name: 'Crawl History',
      },
      {
        path: '/web-crawl/schedules',
        name: 'Schedules',
      },
    ],
  },
  {
    path: '/admin',
    name: 'Admin',
    showWhenFeatureEnabled: 'cloudsine-staff',
    children: [
      {
        path: '/admin/dashboard',
        name: 'Admin home',
      },
      {
        path: '/admin/rendering-engines',
        name: 'Rendering Engines',
      },
      {
        path: '/user-management/list',
        name: 'View Users',
      },
      {
        path: '/user-management/create-account',
        name: 'Create User',
      },
    ],
  },
  {
    path: '/licensing',
    name: 'Licensing',
    children: [
      {
        path: '/licensing/terms-of-service',
        name: 'Terms of Service',
      },
    ],
  },
  {
    path: '/custom-element',
    name: 'Custom Element',
    showWhenFeatureEnabled: 'custom-element',
    children: [
      {
        path: '/custom-element/list',
        name: 'View Elements',
      },
      {
        path: '/custom-element/add',
        name: 'Create Element',
      },
    ],
  },
];
